import { render } from "./ArticleBody.vue?vue&type=template&id=41ba722e&scoped=true"
import script from "./ArticleBody.vue?vue&type=script&lang=js"
export * from "./ArticleBody.vue?vue&type=script&lang=js"

import "./ArticleBody.vue?vue&type=style&index=0&id=41ba722e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ba722e"]])

export default __exports__